import { useSnackbar } from 'notistack';
import { useEffect, useRef, useState } from 'react';

import { useAnalytics } from '~/analytics/useAnalytics';
import { DOCS_AND_GUIDES_LABEL } from '~/components/docs/docsAndGuides';
import { useWhatsNew } from '~/components/whatsNew/useWhatsNew';
import { WhatsNewShowcaseDialog } from '~/components/whatsNew/WhatsNewShowcaseDialog';

export const FIND_IT_LATER = `Watch these demos again any time from What's New at the top of the page, or in ${DOCS_AND_GUIDES_LABEL}.`;

export function WhatsNewShowcase() {
  const { dialogEntries, markDialogSeen } = useWhatsNew();
  const { track } = useAnalytics();
  const { enqueueSnackbar } = useSnackbar();
  const [closedId, setClosedId] = useState<string | null>(null);
  const shownId = useRef<string | null>(null);

  const newestId = dialogEntries[0]?.id;
  const show = Boolean(newestId) && closedId !== newestId;

  const entryCount = dialogEntries.length;
  useEffect(() => {
    if (!show || !newestId || shownId.current === newestId) return;
    shownId.current = newestId;
    track('whats_new_showcase_shown', { entry_count: entryCount, source: 'auto' });
  }, [show, newestId, entryCount, track]);

  if (!show) return null;

  return (
    <WhatsNewShowcaseDialog
      key={newestId}
      entries={dialogEntries}
      onGuideClick={(entry) =>
        track('whats_new_entry_clicked', { entry_id: entry.id, source: 'showcase' })
      }
      onClose={(position, finished) => {
        track('whats_new_showcase_closed', {
          entry_id: dialogEntries[position].id,
          position: position + 1,
          total: dialogEntries.length,
          finished,
          source: 'auto',
        });
        setClosedId(newestId);
        markDialogSeen();
        enqueueSnackbar(FIND_IT_LATER, {
          variant: 'info',
          anchorOrigin: { vertical: 'top', horizontal: 'right' },
          autoHideDuration: 8000,
        });
      }}
    />
  );
}
